import { Loader2 } from "lucide-react";

export function PageSpinner() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <Loader2 className="h-16 w-16 animate-spin text-primary" />
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="rounded-xl border bg-card overflow-hidden">
      <div className="aspect-video bg-muted shimmer" />
      <div className="p-4 space-y-3">
        <div className="h-5 bg-muted shimmer rounded w-3/4" />
        <div className="h-4 bg-muted shimmer rounded w-full" />
        <div className="h-4 bg-muted shimmer rounded w-5/6" />
        <div className="flex justify-between pt-2 border-t">
          <div className="h-4 bg-muted shimmer rounded w-24" />
          <div className="h-4 bg-muted shimmer rounded w-16" />
        </div>
      </div>
    </div>
  );
}

export function SkeletonText({ className = "" }: { className?: string }) {
  return <div className={`h-4 bg-muted shimmer rounded ${className}`} />;
}

export function SkeletonImage({ className = "" }: { className?: string }) {
  return <div className={`bg-muted shimmer rounded ${className}`} />;
}

interface ButtonSpinnerProps {
  className?: string;
}

export function ButtonSpinner({ className = "" }: ButtonSpinnerProps) {
  return <Loader2 className={`h-5 w-5 animate-spin ${className}`} />;
}
